<div class="step-a">
<div class="auth-type-selector">
  <label class="auth-type-option">
    <input type="radio" name="authType" value="user_password" [(ngModel)]="loginData.authType"/>
    <div class="auth-type-card">
      <i class="fa fa-user"></i>
      <span class="auth-type-label" i18n="Radio label for user and password auth method@@connectionWizardTabUserPassword">User + Password</span>
      <span class="auth-type-desc">Sign in with your Power BI account</span>
    </div>
  </label>
  <label class="auth-type-option">
    <input type="radio" name="authType" value="client_credentials" [(ngModel)]="loginData.authType"/>
    <div class="auth-type-card">
      <i class="fa fa-key"></i>
      <span class="auth-type-label" i18n="Radio label for client credentials auth method@@connectionWizardTabClientCredentials">Client Credentials</span>
      <span class="auth-type-desc">Service principal via Azure AD app</span>
    </div>
  </label>
</div>

<ng-container *ngIf="loginData.authType === 'user_password'">
  <h5
    i18n="Text to let the user know to fill in the fields with the Power BI user and password.@@connectionWizardStepA1"
  >
    Fill in the fields with your Power BI application ID, user and password.
  </h5>
  <h5
    i18n="Text to let the user know that only the applications he has access to can be distributed on the Power BI portal@@connectionWizardStepA2"
  >
    Remember that only the applications you have access to can be distributed on the Power BI portal
  </h5>

  <div class="form-group">
    <label title="Type the Application ID">Application ID</label>
    <div class="input-wrapper">
      <input type="text" class="form-control" [(ngModel)]="loginData.applicationId" placeholder="Application ID" name="applicationId" id="applicationId" required #appIdRef="ngModel"/>
    </div>
  </div>

  <div class="form-group">
    <label i18n="Titulo do usuário na página de conexão do wizard@@conectionWizardUserTitle" title="Type your Power BI username">User</label>
    <div class="input-wrapper">
      <input type="text" class="form-control" type="email" [(ngModel)]="loginData.user" i18n="PowerBI username placeholder at connection wizard@@powerBiUsernamePlaceholder" placeholder="Power BI username"  name="email" id="email" #emailref="ngModel" autofocus/>
    </div>
  </div>

  <div class="form-group">
    <label title="Type your Power BI password" i18n="PowerBI password placeholder at connection wizard@@powerBiPasswordPlaceholder">Password</label>
    <div class="input-wrapper">
      <input type="password" class="form-control" [(ngModel)]="loginData.password" [required]="!hasExistingPassword || passwordChanged" [placeholder]="hasExistingPassword ? '••••••••' : ''" name="password" id="password" #passwordref="ngModel" (ngModelChange)="passwordChanged = true"/>
    </div>
    <small *ngIf="hasExistingPassword && !passwordChanged" class="form-text text-muted" i18n="Keep existing password hint@@connectionWizardKeepPassword">Leave blank to keep current password</small>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{error}}
  </div>

  <button
    class="btn btn-info"
    [disabled]="emailref.invalid || appIdRef.invalid || passwordref.invalid"
    title="{{(emailref.invalid || appIdRef.invalid || passwordref.invalid)?'Please type your credentials to continue':'Click to authenticate on Power BI Service'}}"
    (click)="emitLlogin()"
    i18n="generic next button label|Generic message shown in forms where there are multiple steps and there is at least one step after the current one@@genericNextStepButtonLabel"
  >
    Next
  </button>
</ng-container>

<ng-container *ngIf="loginData.authType === 'client_credentials'">
  <div class="form-group">
    <h5
      i18n="Text to let the user know to fill in the fields with client credentials@@connectionWizardStepAClientCredentials"
    >Fill in the fields with your Azure AD application credentials.</h5>
    <label i18n="Client ID label at connection wizard@@connectionWizardClientIdLabel" title="Type your Azure AD Application (client) ID">Client ID</label>
    <div class="input-wrapper">
      <input type="text" class="form-control" [(ngModel)]="loginData.clientId" i18n="Client ID placeholder at connection wizard@@connectionWizardClientIdPlaceholder" placeholder="Application (client) ID" name="clientId" id="clientId" #clientIdRef="ngModel" required autofocus/>
    </div>
  </div>
  <div class="form-group">
    <label i18n="Tenant ID label at connection wizard@@connectionWizardTenantIdLabel" title="Type your Azure AD Directory (tenant) ID">Tenant ID</label>
    <div class="input-wrapper">
      <input type="text" class="form-control" [(ngModel)]="loginData.tenantId" i18n="Tenant ID placeholder at connection wizard@@connectionWizardTenantIdPlaceholder" placeholder="Directory (tenant) ID" name="tenantId" id="tenantId" #tenantIdRef="ngModel" required/>
    </div>
  </div>
  <div class="form-group">
    <label i18n="Client Secret label at connection wizard@@connectionWizardClientSecretLabel" title="Type your Azure AD application client secret">Client Secret</label>
    <div class="input-wrapper">
      <input type="password" class="form-control" [(ngModel)]="loginData.clientSecret" [placeholder]="hasExistingClientSecret ? '••••••••' : 'Client secret value'" name="clientSecret" id="clientSecret" #clientSecretRef="ngModel" [required]="!hasExistingClientSecret || clientSecretChanged" (ngModelChange)="clientSecretChanged = true"/>
    </div>
    <small *ngIf="hasExistingClientSecret && !clientSecretChanged" class="form-text text-muted" i18n="Keep existing client secret hint@@connectionWizardKeepClientSecret">Leave blank to keep current client secret</small>
  </div>
  <div *ngIf="error" class="alert alert-danger">
    {{error}}
  </div>
  <button
    class="btn btn-info"
    [disabled]="!loginData.clientId || !loginData.tenantId || clientSecretRef.invalid"
    title="{{(!loginData.clientId || !loginData.tenantId || clientSecretRef.invalid)?'Please fill in all credential fields to continue':'Click to authenticate with client credentials'}}"
    (click)="emitLlogin()"
    i18n="generic next button label|Generic message shown in forms where there are multiple steps and there is at least one step after the current one@@genericNextStepButtonLabel"
  >Next</button>
</ng-container>
</div>
